import { render, staticRenderFns } from "./ClarityTextArea.vue?vue&type=template&id=1f32bfb7&scoped=true&"
import script from "./ClarityTextArea.vue?vue&type=script&lang=ts&"
export * from "./ClarityTextArea.vue?vue&type=script&lang=ts&"
import style0 from "./ClarityTextArea.vue?vue&type=style&index=0&id=1f32bfb7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f32bfb7",
  null
  
)

export default component.exports